module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('v-radio-group', {
    staticClass: "compact",
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('v-radio', {
      key: option,
      attrs: {
        "color": "primary",
        "label": option,
        "value": option
      }
    })
  }), 1), _vm._v(" "), _c('template', {
    slot: "menu"
  }, [_c('v-list-item', {
    on: {
      "click": _vm.log
    }
  }, [_c('v-list-item-title', [_vm._v("Special Option Menu")])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52cd94c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/OptionsControl.vue
// module id = 2549
// module chunks = 1